import type { GetThemeNormalized as SelectedTheme } from '@messenger/types'
import { getThemeStylesForTemplate } from '@/utils/tinyMCE/templates/getThemeStylesForTemplate'

export const caseDetailSpan = (
  key: string,
  selectedTheme: SelectedTheme | null = null,
  editor?: Editor,
) => {
  const themeStyles = getThemeStylesForTemplate({
    selectedTheme,
    editor,
  })

  return `&#8202;<span class="mceNonEditable" data-case-detail="${key}" style="${themeStyles}">{$${key}}</span>&#8202;`
}

export default caseDetailSpan
